import BackgroundProperty from './BackgroundProperty/BackgroundProperty';
import FontProperty from './FontProperty/FontProperty';
import BorderProperty from './BorderProperty/BorderProperty';
import HyperlinkProperty from './HyperlinkProperty/HyperlinkProperty';

export {
  BackgroundProperty,
  FontProperty,
  BorderProperty,
  HyperlinkProperty,
};
